import { useEffect } from 'react';
import { useSlideshowContext } from '../../SlideshowContext';
import type { ISlideshowButtonProps } from '../../types';
import styles from './skinComps/SlideshowButton.module.scss';
import classNames from 'classnames';

export const useSlideshowButton = (props: ISlideshowButtonProps) => {
  const {
    action,
    isDisabled,
    isDisabledByCtx,
    onDisabledChange,
    a11y,
    label,
    translations,
  } = props;

  const { onButtonClick, isButtonDisabled, setIsButtonFocused } =
    useSlideshowContext();

  const onClick = () => onButtonClick(action);
  const disabled = !!(isDisabled || isDisabledByCtx);
  const onFocus = () => setIsButtonFocused(true);
  const onBlur = () => setIsButtonFocused(false);
  const defaultLabel = {
    next: translations?.ariaLabelNext,
    prev: translations?.ariaLabelPrev,
  };
  const className = classNames(
    styles.root,
    disabled ? styles.disabled : '',
    ...(props.customClassNames || []),
  );

  useEffect(() => {
    const uxDisabled = isButtonDisabled(action);
    if (uxDisabled !== isDisabledByCtx) {
      onDisabledChange?.(uxDisabled);
    }
  }, [isDisabledByCtx, isButtonDisabled, action, onDisabledChange]);

  const updatedA11y = {
    ...a11y,
    label: a11y?.label || label || defaultLabel[action],
  };

  return { disabled, onClick, onFocus, onBlur, updatedA11y, className };
};
